import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { verifyMagicToken } from '../utils/authApi'

export default function MagicLogin() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [error, setError] = useState(token ? '' : 'Geen token gevonden in de link.')
  const navigate = useNavigate()

  useEffect(() => {
    if (!token) return

    verifyMagicToken(token)
      .then((data) => {
        localStorage.setItem('token', data.token)
        localStorage.setItem('user', JSON.stringify(data.user))
        navigate('/dashboard')
        window.location.reload()
      })
      .catch((err) => {
        setError(err.response?.data?.error || 'De link is verlopen of al gebruikt.')
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] bg-gray-50 dark:bg-gray-900 px-4">
        <div className="max-w-md w-full text-center space-y-4">
          <div className="text-4xl">⚠️</div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Link niet geldig</h2>
          <p className="text-gray-600 dark:text-gray-400">{error}</p>
          <a href="/login" className="btn btn-primary inline-block">Opnieuw inloggen</a>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] bg-gray-50 dark:bg-gray-900">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600 mx-auto" />
        <p className="text-gray-600 dark:text-gray-400">Je wordt ingelogd...</p>
      </div>
    </div>
  )
}
